import { APP_DESCRIPTION, APP_META_KEYWORDS, APP_TITLE, APP_URL, PLACEHOLDER_IMAGES } from '@/constants';
import { BreadCrumbs, IProductDetails } from '@/interfaces/product';
import { getBreadcrumbData } from '@/utils/helper';
import { BreadcrumbJsonLd, NextSeo, ProductJsonLd } from 'next-seo';

export default function Meta({
  title,
  description,
  keywords,
  MetaTitle,
  ImageUrl,
  CanonicalTag,
  altTag,
  product,
  breadcrumbs,
}: {
  title?: string;
  description?: string;
  keywords?: string;
  MetaTitle?: string;
  ImageUrl?: string;
  CanonicalTag?: string;
  altTag?: string;
  product?: IProductDetails;
  breadcrumbs?: BreadCrumbs[];
}) {
  return (
    <>
      <NextSeo
        title={`${MetaTitle || title} | ${APP_TITLE}`}
        description={description}
        canonical={CanonicalTag}
        additionalMetaTags={[
          {
            property: 'keywords',
            content: keywords || APP_META_KEYWORDS,
          },
        ]}
        openGraph={{
          url: APP_URL,
          title: MetaTitle || title || APP_TITLE,
          description: description || APP_DESCRIPTION,
          images: [
            {
              url: ImageUrl || PLACEHOLDER_IMAGES.DEFAULT_OG_IMAGE,
              alt: altTag || 'Apex Logo',
              type: 'image/jpeg',
            },
          ],
          site_name: MetaTitle || title,
        }}
      />

      {product && (
        <ProductJsonLd
          productName={product?.Name.replace(/"/g, '')}
          images={product?.ProductImageList?.map((image) => image?.Url)}
          description={product?.FullDescription || product?.ShortDescription}
          sku={product.Sku}
          aggregateRating={{
            ratingValue: `${product?.ProductReviewOverview?.RatingSum || 5}`,
            reviewCount: `${product?.ProductReviewOverview?.TotalReviews || 1}`,
          }}
          manufacturerName={APP_TITLE}
          manufacturerLogo="https://storage.apex4u.com/apex_logo_website_170x80.png"
          // material="steel"
          color={product?.AvailableColors.map((color) => (color?.OwnColor ? color.ColorName : ''))[0]}
          offers={[
            {
              price: `${product?.ProductPrice?.Price}`,
              priceCurrency: 'BDT',
              url: `${APP_URL}/product/${product?.SeName}`,
              // availability: product?.StockQuantity > 0 ? true : false,
            },
            {
              price: `${product?.ProductPrice?.OldPrice}`,
              priceCurrency: 'BDT',
              url: `${APP_URL}/product/${product?.SeName}`,
              // availability: product?.StockQuantity > 0 ? true : false,
            },
          ]}
          brand={product?.ProductBrand?.Name}
        />
      )}

      {breadcrumbs && <BreadcrumbJsonLd itemListElements={getBreadcrumbData(breadcrumbs)} />}
    </>
  );
}
